import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import { GetRecent } from "./API";
import RecentChatItem from "./RecentChatItem";

export default function RecentChats(props) {
  const [data, setData] = useState([]);
  useEffect(() => {
    GetRecent().then(data => {
      setData(data);
    });
  }, []);
  return (
    <div class="col-4 col-xs-12">
      <div
        class="widget-list widget-list-rounded m-b-30"
        data-id="widget"
        data-scrollbar="true"
        data-height="540px"
      >
        {data.map(item => (
          <RecentChatItem langCode={props.langCode} key={item.regnum} {...item} />
        ))}
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/pages/Chat/RecentChats.js